var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.215,
    height: 95.269,
    viewBox: "0 0 95.215 95.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doctor_Icons_2-02",
    "data-name": "Doctor Icons 2-02",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41228",
    "data-name": "Path 41228",
    d: "M186.783,153.88a13.533,13.533,0,0,1,2.972,1.2,8.347,8.347,0,0,1,3.215,3.963,8.248,8.248,0,0,1,4.726-1.982,7.837,7.837,0,0,1,7.634,4.458c.238.5.322.753.931.312a7.407,7.407,0,0,1,8.139-.728,7.812,7.812,0,0,1,4.5,7.079c.094,2.477.045,4.954,0,7.431a1.025,1.025,0,0,0,.753,1.149c11.983,4.919,19.166,13.772,21.123,26.572a31.741,31.741,0,0,1-5.221,22.837c-.466.708-.352,1.05.193,1.59,3.9,3.854,7.773,7.738,11.651,11.617,2.224,2.224,2.219,4.676,0,6.935-.5.5-.961.991-1.451,1.442a4.313,4.313,0,0,1-6.376-.05q-5.945-5.945-11.889-11.914a1.024,1.024,0,0,0-1.6-.139,31.257,31.257,0,0,1-12.32,4.924c-.912.154-1.367.416-1.224,1.432a14.56,14.56,0,0,1,0,2.229,4.772,4.772,0,0,1-4.954,4.889H176.35a4.737,4.737,0,0,1-5.048-5.073V232.344a13.43,13.43,0,0,0-2.972-8.689c-3.542-4.458-7.034-8.971-10.581-13.43a16.616,16.616,0,0,1-3.76-8.55,1.512,1.512,0,0,0-.139-.337V181.032a1.834,1.834,0,0,0,.139-.342c1.075-5.88,4.553-9.412,10.363-10.73.5-.114.634-.312.629-.8,0-2.041-.05-4.087,0-6.128a8.035,8.035,0,0,1,7.376-7.53,7.857,7.857,0,0,1,5.811,1.982c.218.188.406.55.7.074a8.521,8.521,0,0,1,5.449-3.691Zm-18.617,25.131h0v13.014c0,1.02.035,2.046,0,3.066a1.58,1.58,0,0,1-2.214,1.486,1.734,1.734,0,0,1-.951-1.848V174.092c0-1.095,0-1.095-1.085-.778a9.492,9.492,0,0,0-6.861,9.14c-.03,5.608,0,11.216,0,16.843a13.44,13.44,0,0,0,3.022,8.674c3.621,4.563,7.2,9.16,10.809,13.727a16.472,16.472,0,0,1,3.646,10.586q0,5.8,0,11.617c0,1.486.54,2.036,1.982,2.041h30.862c1.486,0,2.031-.555,2.056-2.011,0-.649-.045-1.3,0-1.952s-.149-.9-.872-.862a28.639,28.639,0,0,1-7.659-.679A33.126,33.126,0,0,1,174.889,203.1a32.047,32.047,0,0,1,15.882-23.818,32.47,32.47,0,0,1,24.244-3.928c.436.094.768.233.763-.451-.03-2.264.059-4.528-.04-6.787a4.82,4.82,0,0,0-5.945-4.543,4.716,4.716,0,0,0-3.537,4.186c-.134,1.382-.689,2.021-1.709,1.982s-1.486-.723-1.486-2.145v-2.418a4.988,4.988,0,0,0-4.612-4.954c-2.531-.139-4.582,1.788-4.9,4.577-.144,1.229-.723,1.818-1.714,1.744s-1.456-.743-1.486-1.907c0-1.02.025-2.046-.03-3.066a4.9,4.9,0,0,0-4.429-4.508,4.775,4.775,0,0,0-4.919,3.691,9.832,9.832,0,0,0-.134,2.219c0,1.253-.59,1.982-1.56,2.021s-1.486-.674-1.625-1.877a4.622,4.622,0,0,0-3.166-4.2,4.783,4.783,0,0,0-6.316,4.567C168.137,168.657,168.167,173.834,168.167,179.011Zm39.675,58.951a29.751,29.751,0,1,0,0,.01Zm34.969,7.951a1.367,1.367,0,0,0,.991-.5c.525-.525,1.06-1.04,1.575-1.58.748-.783.758-1.3,0-2.071-2.477-2.477-5-4.989-7.485-7.5-.312-.317-.52-.426-.882-.045-.892.946-1.813,1.863-2.759,2.759-.391.367-.253.575.054.877q3.76,3.74,7.5,7.49a1.486,1.486,0,0,0,1.011.57ZM235.1,231.546c-.124-.139-.218-.258-.327-.362-.391-.4-.812-.768-1.174-1.189s-.609-.5-.991,0c-.461.58-1.03,1.07-1.521,1.625s-1.461.9-1.357,1.486.951,1.07,1.442,1.625c.3.327.5.347.817,0,.921-.956,1.873-1.887,2.814-2.829a1.655,1.655,0,0,0,.3-.327Z",
    transform: "translate(-153.849 -153.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41229",
    "data-name": "Path 41229",
    d: "M236.854,253.588a27.034,27.034,0,0,1,.406-6.316,33.381,33.381,0,0,1,1.972-4.924c.991-2.239,1.982-4.458,2.972-6.7a11.781,11.781,0,0,0,1.016-4.87V213.759c0-.723-.2-1.09-.916-1.194a5.83,5.83,0,0,1-.991-.287,1.58,1.58,0,1,1,.872-3.027,22.522,22.522,0,0,1,3.512,1.184,27,27,0,1,1-14.584-1.774,27.75,27.75,0,0,1,3.79-.332c1.179,0,1.912.575,1.952,1.531s-.7,1.585-1.937,1.64c-9.546.441-16.689,4.83-21,13.351-7.114,14.079,1.694,31.209,17.264,33.894a26.637,26.637,0,0,0,4.9.352c.594,0,.812-.193.8-.807C236.854,256.813,236.854,255.327,236.854,253.588Zm9.516-39.294v16.3a15.57,15.57,0,0,1-1.362,6.49c-1.328,2.972-2.635,5.945-3.963,8.917a11.294,11.294,0,0,0-1.03,4.771c0,2.323.035,4.647,0,6.97,0,.822.233.892.961.708A23.475,23.475,0,0,0,258.76,238.8c1.308-10.012-2.477-17.913-10.829-23.6a15.933,15.933,0,0,0-1.541-.907Z",
    transform: "translate(-181.296 -181.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41230",
    "data-name": "Path 41230",
    d: "M269.215,223.592v.555a1.653,1.653,0,0,1-1.625,1.773c-.916-.02-1.516-.718-1.541-1.833v-1.3a1.575,1.575,0,0,1,1.546-1.63,1.61,1.61,0,0,1,1.6,1.486,7.224,7.224,0,0,1,0,.926Z",
    transform: "translate(-210.466 -187.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41231",
    "data-name": "Path 41231",
    d: "M230.693,278.008v.743a1.59,1.59,0,0,1-1.551,1.63,1.62,1.62,0,0,1-1.605-1.6,12.376,12.376,0,0,1,0-1.486,1.625,1.625,0,0,1,1.625-1.674c.892,0,1.486.7,1.536,1.739A4.059,4.059,0,0,1,230.693,278.008Z",
    transform: "translate(-191.022 -215.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41232",
    "data-name": "Path 41232",
    d: "M253.221,258.732c0-.277-.025-.56,0-.832a1.566,1.566,0,1,1,3.131-.05,8.942,8.942,0,0,1,0,1.669,1.575,1.575,0,1,1-3.146-.045v-.743Z",
    transform: "translate(-203.984 -205.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41233",
    "data-name": "Path 41233",
    d: "M230.7,246.046c0,1.59-.5,2.333-1.585,2.318s-1.58-.778-1.575-2.368a6.3,6.3,0,0,1,.04-.991,1.57,1.57,0,0,1,1.63-1.347,1.536,1.536,0,0,1,1.486,1.486A6.064,6.064,0,0,1,230.7,246.046Z",
    transform: "translate(-191.03 -199.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41234",
    "data-name": "Path 41234",
    d: "M230.691,262.018v.743a1.526,1.526,0,0,1-1.556,1.6,1.565,1.565,0,0,1-1.6-1.58,11.365,11.365,0,0,1,0-1.486,1.57,1.57,0,0,1,1.625-1.645c.926.015,1.486.649,1.541,1.714v.649Z",
    transform: "translate(-191.02 -207.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41235",
    "data-name": "Path 41235",
    d: "M243.52,265.322v.649a1.575,1.575,0,1,1-3.151.03,10.447,10.447,0,0,1,0-1.575,1.576,1.576,0,0,1,3.151.059C243.535,264.762,243.52,265.044,243.52,265.322Z",
    transform: "translate(-197.494 -208.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41236",
    "data-name": "Path 41236",
    d: "M265.995,239.548V238.9a1.557,1.557,0,0,1,1.565-1.689,1.588,1.588,0,0,1,1.6,1.689,12.532,12.532,0,0,1,0,1.293c-.055,1.1-.684,1.759-1.64,1.734s-1.486-.659-1.526-1.729C265.995,239.984,265.995,239.766,265.995,239.548Z",
    transform: "translate(-210.437 -195.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41237",
    "data-name": "Path 41237",
    d: "M253.239,242.733c0-1.585.5-2.348,1.575-2.333s1.585.778,1.58,2.363a5.792,5.792,0,0,1-.05,1.016,1.556,1.556,0,0,1-3.1-.119A8.239,8.239,0,0,1,253.239,242.733Z",
    transform: "translate(-203.997 -197.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41238",
    "data-name": "Path 41238",
    d: "M266.056,255.568c0-1.6.5-2.328,1.575-2.318s1.585.753,1.58,2.348a5.493,5.493,0,0,1-.064,1.1,1.559,1.559,0,0,1-3.086-.208A7.229,7.229,0,0,1,266.056,255.568Z",
    transform: "translate(-210.463 -204.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41239",
    "data-name": "Path 41239",
    d: "M253.247,290.793c0-1.6.5-2.348,1.565-2.343s1.6.773,1.59,2.353a6.282,6.282,0,0,1-.045,1.016,1.549,1.549,0,0,1-3.086-.124,8.251,8.251,0,0,1-.025-.9Z",
    transform: "translate(-204.005 -221.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41240",
    "data-name": "Path 41240",
    d: "M253.17,226.779a9.15,9.15,0,0,1,.079-1.11,1.551,1.551,0,0,1,3.007-.139,4.914,4.914,0,0,1,0,2.477,1.551,1.551,0,0,1-3.007-.119,9.125,9.125,0,0,1-.079-1.11Z",
    transform: "translate(-203.968 -189.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41241",
    "data-name": "Path 41241",
    d: "M243.555,249.193a9.951,9.951,0,0,1-.055,1.016,1.486,1.486,0,0,1-1.486,1.357,1.447,1.447,0,0,1-1.56-1.288,8.487,8.487,0,0,1-.059-1.843,1.575,1.575,0,1,1,3.151,0v.743Z",
    transform: "translate(-197.509 -200.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41242",
    "data-name": "Path 41242",
    d: "M253.179,274.839a9.95,9.95,0,0,1,.054-1.016,1.486,1.486,0,0,1,1.486-1.352,1.422,1.422,0,0,1,1.57,1.268,8.392,8.392,0,0,1,.03,2.026,1.486,1.486,0,0,1-1.645,1.4,1.516,1.516,0,0,1-1.486-1.486c-.025-.277,0-.555,0-.832Z",
    transform: "translate(-203.972 -213.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41243",
    "data-name": "Path 41243",
    d: "M243.5,233.152a9.122,9.122,0,0,1-.079,1.1,1.551,1.551,0,0,1-3.007.144,4.914,4.914,0,0,1,0-2.477,1.412,1.412,0,0,1,1.6-1.12,1.432,1.432,0,0,1,1.412,1.234A9.133,9.133,0,0,1,243.5,233.152Z",
    transform: "translate(-197.453 -192.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41244",
    "data-name": "Path 41244",
    d: "M243.514,281.334a7.78,7.78,0,0,1,0,.832,1.56,1.56,0,0,1-3.116.04,9.421,9.421,0,0,1,0-1.754,1.57,1.57,0,0,1,3.136.05v.832Z",
    transform: "translate(-197.503 -217.008)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorIcon1);
export default __webpack_public_path__ + "static/media/doctor-icon1.656da336d0cdefda114baa619c2da6f0.svg";
export { ForwardRef as ReactComponent };